<template>
  <div class="d-flex align-items-center py-3 " style="width:100%">
    <div class="select-con d-flex align-items-center justify-content-end" style="width:100%">
      <label class="flex-shrink-0 mr-3" style="font-size:18px; margin-bottom: 0">选择展会:</label>
      <el-select filterable  :filter-method="searchExi" :loading="loading" v-model="exiOid" :placeholder="placeholder" @change="changeExi">
        <el-option v-for="item in exiList" :key="item.oid" :label="item.exi_name" :value="item.oid">
        </el-option>
      </el-select>
    </div>
    <a v-if="userInfo.company_type != '001'" class="ml-3 btn btn-m btn-info flex-shrink-0" download="" target="_blank" :href="
        appsettings.apiroot +
          'exiexhibitor/poster?exi_oid=' +
          exiOid +
          '&token=' +
          userInfo.token + '&company_oid=' + userInfo.company_oid
      ">
      打印展牌
    </a>
  </div>
</template>

<script>
import appsettings from "../utils/appsettings";
import { fetch } from "../utils/request";
export default {
  props: ["exhibitor"],
  data () {
    return {
      appsettings: appsettings,
      userInfo: {},
      userMenus: [],
      exiList: [],
      exiOid: "",
      loading: false,
      query_data: {
        page_index: 1,
        page_size: 100000,
        exi_name: ""
      },
      placeholder: ""
    };
  },
  computed: {
    editExi () {
      return this.$store.state.isEditExi;
    }
  },
  watch: {
    editExi: {
      immediate: true,
      handler: function (val) {

        if (val != 0) {
          this.queryExiList();
        }
      }
    }
  },
  mounted () {
    this.userInfo = this.$store.state.userInfo;
    this.query_data.company_oid = this.userInfo.company_oid;
    this.queryExiList();
  },
  methods: {
    queryExiList () {
      var url =
        this.$store.state.userInfo.company_type != "001"
          ? "/eximain/retrieve/byexhibitor"
          : "/eximain/retrievebyuserexi";
      fetch("post", url, this.query_data).then(res => {
        if (res.status == 0) {
          this.exiList = res.data.datas;
          this.placeholder =
            this.exiList.length > 0 ? "请选择展会" : "暂无参加的展会";

          this.exiOid =
            this.$store.state.exiOid &&
              this.$store.state.isEditExi == 0 &&
              this.$store.state.deleteExi != this.$store.state.exiOid
              ? this.$store.state.exiOid
              : res.data.datas.length > 0
                ? res.data.datas[0].oid
                : "";
          this.$emit("newExi", this.exiOid);
          let selectExi = this.exiList.filter(this.checkAdult);
          if (selectExi.length > 0) {
            this.$emit("showLive", selectExi[0].show_live);
          }
          this.loading = false;
        }
      });
    },
    changeExi () {
      let selectExi = this.exiList.filter(this.checkAdult);
      if (selectExi.length > 0) {
        this.$emit("showLive", selectExi[0].show_live);
      }
      this.$emit("newExi", this.exiOid);
    },
    checkAdult (item) {
      return item.oid == this.exiOid;
    },
    searchExi (query) {
      if (query == "") return;
      this.loading = true;
      // 获取展会
      this.query_data.exi_name = query;
      this.queryExiList();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/selectExi.vue